/**
 * 新的上报形式，在页面间上报，确保上报的数据全 & 准确
 * https://docs.google.com/spreadsheets/d/1Q_iBQKX1mycmtoz7Mi4I729TTevCTgvDaFipRs_c2vg/edit#gid=0
 * 老的上报后续干掉
 * @Author: moonye
 * @Date: 2018-06-20 10:17:32
 * @Last Modified by: moonye
 * @Last Modified time: 2019-11-20 10:52:58
 */

import tdw from './tdw/tdw-local';
import { getCookieData, setCookieData } from './lib/report.cookie';
import channelProcess from './lib/report.channel';
import uinProcess from './lib/report.uin';
import positionProcess from './lib/report.position';
import injectUtil from './lib/util.inject';
import util from './lib/util';
import { getTestid } from './lib/testidHandler';
import { getSessionFlowid } from './lib/sessionIdHandler';
const pathname = location.pathname;
const loc = window.location;
let report = {};

// 标记上报是否全局初始化过
const isReportorInit = window.isReportorInit;
// local 是否加载过，避免多次注册 local 回调
let isLocalProxyInit = false;

// 配置，教育相关
// config 直接配置的是基本信息，独立于页面之外的
function initConfig(o) {
  o.config({
    opername: 'edu',
    platform: util.getPlatform(), // 1PC 2H5 3native andriod 4native ios 5PC独立客户端win 6 pc独立端mac 7小程序 9 win极速客户端， 10 mac极速客户端
    // environment: '', // PC为空 H5填取到的app 如edu_APP，如QQ
    // phonetype: '', // android ios
    url: loc.href,
    refer: document.referrer,
  },
    {
      table: 'dc03514',
      pr_ip: 'clientip',
      pr_t: 'reporttime',
      slicer: 4
    }
  );
}

report.config = function (param = {}, tableConfig = {}) {
  tdw.config(Object.assign({}, param), tableConfig);
  if (param.closeLocal !== true && !isLocalProxyInit) {
    isLocalProxyInit = true;
    tdw.initLocal &&
      tdw.initLocal({
        whiteDomain: ['ke.qq.com'],
        crossProxy: '//ke.qq.com/storage_proxy.html',
        crossDomain: true
      });
  }
};

report.tdw = function (data, isSync) {
  tdw[isSync ? 'reportSync' : 'report'](data);
};

report.getReportData = tdw.getCommonData;

/**
 * 上报 pageview 相关事件，将接口暴露给最外面使用
 * @param {obj} ext
 */
report.reportPageView = function (ext = {}) {
  if (~pathname.indexOf('/storage_proxy.html')) {
    return;
  }

  report.tdw(Object.assign({
    action: 'pageview',
    url_testid: getTestid(),
    url_session_flowid: getSessionFlowid()
  }, ext));
};

(() => {
  if (isReportorInit) {
    report = window.reportorHandler;
    initConfig(report);
    console.warn('上报已初始化，请确保一个页面只引用一次上报');
    return;
  }

  // 做一个标记，一个页面只允许初始一次
  window.isReportorInit = true;
  window.reportorHandler = report;

  initConfig(tdw);

  injectUtil.injectHref();
  const dataFromCookie = getCookieData();
  channelProcess(dataFromCookie);
  uinProcess(dataFromCookie);
  positionProcess(dataFromCookie, report);
  tdw.config(dataFromCookie);
  setCookieData(dataFromCookie); // 也要种个 session cookie ，保证其他页面可用
})();

export default report;

